/* eslint-disable */
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Select from "react-select";

import VatOptions from "data/Invoice/VAT.json";

import * as url from "helper/UrlHelper";
import { deleteData, getData, postData, putData } from "utils/Gateway";

//import translation function for language translation
import { useTranslation } from "react-i18next";

//import current date
import { getCurrentDateInString } from "helper/getcurrentdatestring";
import NoteSection from "../../NoteComponent/NoteSection";
import { reactSelectStyle } from "Config/Config";

const SaveInvoicePopup = ({
  selectedInvoiceId,
  setSelectedInvoiceId,
  setReloadData,

  setShowAlert,
  setAlertMessage,
  setMessageType,
}) => {
  const { t } = useTranslation(); //for translation
  const token = localStorage.getItem("token");

  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const params = useParams();

  const [followersInput, setFollowersInput] = useState("");
  const [followersOptions, setFollowersOptions] = useState([]);

  const [invoiceLeadId, setinvoiceLeadId] = useState(null);
  const [invoiceContactId, setinvoiceContactId] = useState(null);

  const [invoiceContactPersonId, setinvoiceContactPersonId] = useState(null);

  const [ownerName, setownerName] = useState("");
  const [title, settitle] = useState("");
  const [description, setdescription] = useState("");
  const [totalAmount, setTotalAmount] = useState(0);
  const [promisePercent, setpromisePercent] = useState("");
  const [followersValue, setFollowersValue] = useState(null);
  const [selctedFollowers, setSelectedFollowers] = useState([]);
  const [totalTax, setTotalTax] = useState(0);
  const [totalDiscount, setTotalDiscount] = useState(0);
  const [payableAmount, setPayableAmount] = useState(0);
  const [noteList, setNoteList] = useState([]);

  const [invoiceOwnerId, setinvoiceOwnerId] = useState(null);

  const invoiceItemTemplate = {
    _id: null,
    description: "",
    quantity: 0,
    price: 0,
    discountpercent: 0,
    discount: 0,
    taxpercent: 0,
    tax: 0,
    amount: 0,
    taxselectedvalue: null, // non-functional used for mapping react select
  };

  const [invoiceItemsList, setInvoiceItemsList] = useState([]);

  const [isSaving, setIsSaving] = useState(false);

  // validation of invoice
  const [errors, setErrors] = useState({});

  //requirements of leads/contacts
  const [firstName, setfirstName] = useState("");
  const [lastName, setlastName] = useState("");
  const [emailAddress, setemailAddress] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [company, setcompany] = useState("");
  const [position, setposition] = useState("");
  const [address, setaddress] = useState("");
  const [city, setcity] = useState("");
  const [state, setstate] = useState("");
  const [country, setcountry] = useState("");
  const [zipcode, setzipcode] = useState("");

  const [noteAccessUserList, setnoteAccessUserList] = useState([]);

  const onFollowersInputChange = (val) => {
    setFollowersInput(val);
  };

  const getFollowersOptions = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_USERLIST_OPTIONS +
        `?userstringinput=${followersInput}`;

      const response = await getData(requestUrl);

      if (response.status) {
        setFollowersOptions(response.data);
      }
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
    }
  };

  const followersSelectionHandler = (val) => {
    setFollowersValue(val);
    setSelectedFollowers(val.map((item) => item.value));
  };

  // on click of Add item
  const addNewInvoiceItem = () => {
    setInvoiceItemsList([...invoiceItemsList, invoiceItemTemplate]);
  };

  // on click delete a invoice item
  const onDeleteInvoiceItem = (index) => {
    const deletedItemBlock = [...invoiceItemsList];
    deletedItemBlock.splice(index, 1);
    setInvoiceItemsList(deletedItemBlock);
  };

  //update invoice item block
  const updateInvoiceBlock = (invoiceItems) => {
    const invoiceItemsArr = invoiceItems.map((invoiceItem) => {
      let invoiceItemSavedData = {
        _id: invoiceItem._id ?? null,
        description: invoiceItem.description ?? "",
        quantity: invoiceItem.unit ?? "",
        price: invoiceItem.price ?? "",
        discountpercent: invoiceItem.discountpercent ?? 0,
        discount: invoiceItem.discountamount ?? 0,
        taxpercent: invoiceItem.taxpercent ?? 0,
        tax: invoiceItem.taxamount ?? 0,
        amount: invoiceItem.totalprice ?? 0,
        taxselectedvalue: getTaxSelectedSelectOptionValue(
          invoiceItem.taxpercent
        ), // non-functional used for mapping react select
      };

      return invoiceItemSavedData;
    });

    setInvoiceItemsList(invoiceItemsArr);
  };

  //change invoice item input value
  const changeInvoiceItemsInputs = (index, field, value) => {
    const updatedFormValues = invoiceItemsList.map((block, i) =>
      index === i ? { ...block, [field]: value } : block
    );

    setInvoiceItemsList(updatedFormValues);

    updateItemGrossValues(index, updatedFormValues);
  };

  //function for select tax
  const taxSelectionHandler = (index, val) => {
    const updatedFormValues = invoiceItemsList.map((block, i) =>
      index === i
        ? { ...block, taxselectedvalue: val, taxpercent: val.value }
        : block
    );

    setInvoiceItemsList(updatedFormValues);

    updateItemGrossValues(index, updatedFormValues);
  };

  // update invoice calculation
  const invoiceItemUpdateHandler = () => {
    const updatedItems = [...invoiceItemsList];

    const totalAmount = updatedItems.reduce(
      (amount, item) => amount + item.price * item.quantity,
      0
    );

    const totalTax = updatedItems.reduce((tax, item) => tax + item.tax, 0);

    const totalDiscount = updatedItems.reduce(
      (disount, item) => disount + item.discount,
      0
    );

    const payableAmount = updatedItems.reduce(
      (totalamount, item) => totalamount + item.amount,
      0
    );

    setTotalAmount(totalAmount);
    setTotalTax(totalTax);
    setTotalDiscount(totalDiscount);
    setPayableAmount(payableAmount);

    if (totalAmount > 0 && errors.price) {
      setErrors((prev) => ({ ...prev, price: "" }));
    }
  };

  // on update or view, show the pre-selected value of Tax for each invoice items
  const getTaxSelectedSelectOptionValue = (val) => {
    let selectedVatOption = {};

    for (let vatOption of VatOptions) {
      if (vatOption.value === val.toString()) {
        selectedVatOption = vatOption;
      }
    }

    return selectedVatOption;
  };

  // set dependent item value on params change
  const updateItemGrossValues = (index, items) => {
    const currentItems = items || invoiceItemsList;
    const updatedItems = [...currentItems];
    const quantity = parseInt(updatedItems[index].quantity, 10) || 0;
    const price = parseInt(updatedItems[index].price, 10) || 0;
    const tax = parseInt(updatedItems[index].taxpercent, 10) || 0;

    if (quantity > 0 && price > 0) {
      const taxToPay = (quantity * price * tax) / 100;
      const totalPrice = quantity * price + taxToPay;

      updatedItems[index].tax = taxToPay;
      updatedItems[index].amount = totalPrice;

      setInvoiceItemsList(updatedItems);
    }
  };

  // function for validation
  const validateForm = () => {
    const newErrors = {};

    if (!title.trim()) {
      newErrors.title = t("Opportunity title is required.");
    }

    if (!totalAmount || totalAmount <= 0) {
      newErrors.price = t(
        "Total amount must be calculated and greater than zero."
      );
    }

    if (!promisePercent || promisePercent <= 0) {
      newErrors.percent = t("Promise percent must be a positive value.");
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  //* save the invoice record */
  const saveInvoice = async () => {
    if (!validateForm()) {
      setAlertMessage("Please fill up all required fields");
      setMessageType("error");
      setShowAlert(true);
      return;
    }

    setIsSaving(true);

    let invoiceData = {
      leadid: invoiceLeadId || null,
      contactid: invoiceContactId || null,
      clientid: invoiceContactPersonId || null,
      title,
      description,
      amount: totalAmount,
      promisepercent: promisePercent,
      followers: selctedFollowers,
      invoicedate: getCurrentDateInString(),
      duedate: getCurrentDateInString(),
      totaltax: totalTax,
      totaldiscount: totalDiscount,
      payableamount: payableAmount,
      currency: "euro",
      items: invoiceItemsList,
      status: "1",
      notes: [],
      typeslug: "MOD_OPPORTUNITY",
    };

    let requestUrl = url.API_BASE_URL;

    let response = {};

    try {
      if (selectedInvoiceId) {
        requestUrl +=
          url.API_UPDATE_INVOICE + `/${selectedInvoiceId}`;

        response = await putData(requestUrl, invoiceData);
      } else {
        requestUrl += url.API_CREATE_INVOICE;

        response = await postData(requestUrl, invoiceData);
      }

      setIsSaving(false);

      if (response.status) {
        setMessageType("success");
        let offCanvasPopup = document.querySelector("#saveInvoice");
        let offCanvas = bootstrap.Offcanvas.getInstance(offCanvasPopup);
        offCanvas.hide();

        resetHandler();

        setReloadData(true);
      } else {
        setMessageType("error");
      }

      setAlertMessage(response.message);
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
    }

    setShowAlert(true);
  };

  //* get the invoice details */
  const getInvoiceDetails = async () => {
    let requestUrl =
      url.API_BASE_URL +
      url.API_INVOICE_DETAILS +
      `/${selectedInvoiceId}` +
      ``;

    try {
      const response = await getData(requestUrl);

      if (response.status) {
        const invoiceData = response.data;

        setinvoiceLeadId(invoiceData.leadid ? invoiceData.leadid._id : null);

        setinvoiceContactPersonId(
          invoiceData.client ? invoiceData.client._id : null
        );
        settitle(invoiceData.title);
        setdescription(invoiceData.description);
        setpromisePercent(invoiceData.promisepercent);
        followersSelectionHandler(invoiceData.followerslist);
        setinvoiceOwnerId(invoiceData.user._id);
        setownerName(invoiceData.ownername);

        if (invoiceData.invoiceitems && invoiceData.invoiceitems.length > 0) {
          updateInvoiceBlock(invoiceData.invoiceitems);
        } else {
          setTotalAmount(invoiceData.amount);
        }
        setNoteList(invoiceData.notes);

        if (invoiceData.leadid) {
          getLeadDetails(invoiceData.leadid._id);
        }

        if (invoiceData.client) {
          getContactUserDetails(invoiceData.client._id);
        }

        if (invoiceData.contactid) {
          setinvoiceContactId(invoiceData.contactid);
        }

        const allFollowerIds = response.data.followers
          ? response.data.followers.map((item) => item._id)
          : [];

        const appendedNoteFollowers = [
          ...allFollowerIds,
          response.data.user._id,
        ];

        const filterNoteFollowers = appendedNoteFollowers.filter(
          (item) => item.toString() !== userInfo._id.toString()
        );

        setnoteAccessUserList(filterNoteFollowers);

        // Show the offcanvas after setting the state
        let offCanvasPopup = document.querySelector("#saveInvoice");
        let offCanvas = new bootstrap.Offcanvas(offCanvasPopup);
        offCanvas.show();
      }
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
    }
  };

  const resetHandler = () => {
    setErrors({});

    const followersObj = [
      {
        label: `${userInfo.name ?? userInfo.email} ${
          userInfo.surname ? userInfo.surname : null
        }`,
        value: userInfo._id,
      },
    ];

    followersSelectionHandler(followersObj);

    settitle("");
    setdescription("");
    setpromisePercent("");
    setInvoiceItemsList([]);
    setTotalAmount(0);
    setTotalTax(0);
    setTotalDiscount(0);
    setPayableAmount(0);
    setFollowersInput("");
    setFollowersOptions([]);
    setNoteList([]);
    setSelectedInvoiceId(null);
    // addNewInvoiceItem();

    //reset information
    setfirstName("");
    setlastName("");
    setemailAddress("");
    setPhoneNumber("");
    setDateOfBirth("");
    setcompany("");
    setposition("");
    setcity("");
    setstate("");
    setcountry("");
    setzipcode("");
  };

  //function for get lead details
  const getLeadDetails = async (leadId) => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_LEAD_DETAILS +
        `/${leadId}`;

      const response = await getData(requestUrl);

      if (response.status) {
        setfirstName(response.data.name);
        setlastName(response.data.surname);
        setemailAddress(response.data.email);
        setPhoneNumber(response.data.phone);

        if (response.data.dob) {
          if (response.data.dob.includes("-")) {
            let components = response.data.dob.split("-");
            let year = components[0];
            let month = components[1];
            let day = components[2];
            let newDate = day + "-" + month + "-" + year;
            setDateOfBirth(newDate);
          }
        } else {
          setDateOfBirth("");
        }

        setcompany(response.data?.company ?? "");
        setposition(response.data?.position ?? "");
        setcity(response.data?.city ?? "");
        setstate(response.data?.state ?? "");
        setcountry(response.data?.country ?? "");
        setzipcode(response.data?.zipcode ?? "");
        setaddress(response.data?.address ?? "");
      } else {
        setMessageType("error");
        setAlertMessage(response.message);
        setShowAlert(true);
      }
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
      setShowAlert(true);
    }
  };

  //function for get contact user details
  const getContactUserDetails = async (userId) => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_USER_DETAILS +
        `/${userId}` +
        ``;

      const response = await getData(requestUrl);

      if (response.status && response.data) {
        setfirstName(response.data.name);
        setlastName(response.data.surname);
        setemailAddress(response.data.email);
        setPhoneNumber(response.data.phone);

        if (response.data.dob) {
          let components = response.data.dob.split("-");
          let year = components[0];
          let month = components[1];
          let day = components[2];
          let newDate = day + "-" + month + "-" + year;
          setDateOfBirth(newDate);
        } else {
          setDateOfBirth("");
        }

        setcompany(response.data?.company ?? "");
        setposition(response.data?.position ?? "");
        setcity(response.data?.city ?? "");
        setstate(response.data?.state ?? "");
        setcountry(response.data?.country ?? "");
        setzipcode(response.data?.zipcode ?? "");
        setaddress(response.data?.address ?? "");
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  // get client list and default UI
  useEffect(() => {
    const followersObj = [
      {
        label: `${userInfo.name ?? userInfo.email} ${
          userInfo.surname ? userInfo.surname : null
        }`,
        value: userInfo._id,
      },
    ];

    followersSelectionHandler(followersObj);

    if (invoiceItemsList.length === 0) {
      addNewInvoiceItem();
    }
  }, []);

  // update cost and other info when any invoiceitem data changes in invoice
  useEffect(() => {
    invoiceItemUpdateHandler();
  }, [invoiceItemsList]);

  // get saved invoice data to show and update
  useEffect(() => {
    if (selectedInvoiceId) {
      getInvoiceDetails();
    }
  }, [selectedInvoiceId]);

  useEffect(() => {
    if (followersInput.length > 0) {
      getFollowersOptions();
    }
  }, [followersInput]);

  //options for company list in select
  const salesPersonOptionsToShow =
    followersOptions.length > 0 ? followersOptions : [];

  // Custom styles for members
  const customStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: errors.followers ? "#dc3545" : "#ced4da",
      "&:hover": {
        borderColor: errors.followers ? "#dc3545" : "#ced4da",
      },
      borderRadius: "7px",
      padding: "3px",
      minHeight: "40px",
      boxShadow: "none",
    }),
    placeholder: (base) => ({
      ...base,
      fontSize: "0.875rem",
      color: "#6c757d",
    }),
    input: (base) => ({
      ...base,
      fontSize: "0.875rem",
    }),
    singleValue: (base) => ({
      ...base,
      fontSize: "0.875rem",
    }),
  };

  return (
    <div
      className="offcanvas invoice_w offcanvas-end bg-white border-0"
      tabIndex="-1"
      id="saveInvoice"
      aria-labelledby="saveInvoice"
    >
      <div className="offcanvas-header bg-primary text-white p-4 pe-5 pb-3 border-bottom border-gray-300">
        <div className="d-flex align-items-center gap-3">
          <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
            <span className="material-symbols-outlined text-primary fs-5 icon-md">
              trending_up
            </span>
          </div>
          <div>
            <h3
              className="offcanvas-title fw-bold text-white mb-0"
              id="offcanvasLabelDetailsLabel"
            >
              {t("Save Opportunity")}
            </h3>
            <p className="text-white fs-sm mb-0">
              {t("Define a new opportunity")}
            </p>
          </div>
        </div>
        <button
          type="button"
          className="btn-close p-1 bg-gray-200 rounded-circle shadow-sm border-0"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={resetHandler}
        ></button>
      </div>
      <div className="offcanvas-body p-4">
        <div className="row">
          <div className="col-lg-8">
            <div className="p-3 p-md-4 border border-gray-300 rounded-10 shadow-sm">
              <form
                onSubmit={(e) => e.preventDefault()}
                className="d-flex flex-column h-100"
              >
                <div className="fields-container flex-fill">
                  {/* <!-- ========== Start moderator Section ========== --> */}
                  {ownerName === "" ? null : (
                    <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                      <label
                        htmlFor="labelName"
                        className="d-block fs-sm fw-semibold mb-2 text-dark"
                      >
                        Moderator
                      </label>
                      <p className="form-control fs-sm shadow-none border border-gray-300">
                        {ownerName}
                      </p>
                    </div>
                  )}
                  {/* <!-- ========== End moderator Section ========== --> */}

                  {/* <!-- ========== Start title Section ========== --> */}
                  <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                    <label
                      htmlFor="title"
                      className="d-block fs-sm fw-semibold mb-2 text-dark"
                    >
                      Title
                    </label>
                    <input
                      type="text"
                      id="title"
                      className={`form-control fs-sm shadow-none ${
                        errors.title ? "is-invalid" : "border border-gray-300"
                      }`}
                      placeholder="Enter here"
                      value={title}
                      onChange={(e) => {
                        settitle(e.target.value);
                        if (errors.title)
                          setErrors((prev) => ({ ...prev, title: "" }));
                      }}
                    />
                    {errors.title && (
                      <div className="invalid-feedback d-block">
                        {errors.title}
                      </div>
                    )}
                  </div>
                  {/* <!-- ========== End title Section ========== --> */}

                  {/* <!-- ========== Start description Section ========== --> */}
                  <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                    <label
                      htmlFor="description"
                      className="d-block fs-sm fw-semibold mb-2 text-dark"
                    >
                      Description
                    </label>
                    <textarea
                      name="description"
                      id="description"
                      rows="5"
                      className="form-control fs-sm shadow-none border border-gray-300"
                      value={description}
                      onChange={(e) => {
                        setdescription(e.target.value);
                      }}
                    ></textarea>
                  </div>
                  {/* <!-- ========== End description Section ========== --> */}

                  {/* <!-- ========== Start amount, percent and salesperson Section ========== --> */}
                  <div className="row">
                    {/* <!-- ========== Start amount Section ========== --> */}
                    <div className="col-3">
                      <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                        <label
                          htmlFor="price"
                          className="d-block fs-sm fw-semibold mb-2 text-dark"
                        >
                          Price
                        </label>
                        <p
                          id="price"
                          className={`form-control fs-sm shadow-none ${
                            errors.price
                              ? "is-invalid"
                              : "border border-gray-300"
                          }`}
                        >
                          {totalAmount}
                        </p>
                        {errors.price && (
                          <div className="invalid-feedback d-block">
                            {errors.price}
                          </div>
                        )}
                      </div>
                    </div>
                    {/* <!-- ========== End amount Section ========== --> */}

                    {/* <!-- ========== Start percent Section ========== --> */}
                    <div className="col-3">
                      <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                        <label
                          htmlFor="promisePercent"
                          className="d-block fs-sm fw-semibold mb-2 text-dark"
                        >
                          Promise Percent
                        </label>
                        <input
                          type="number"
                          id="promisePercent"
                          className={`form-control fs-sm shadow-none ${
                            errors.percent
                              ? "is-invalid"
                              : "border border-gray-300"
                          }`}
                          placeholder="Enter here"
                          value={promisePercent}
                          onChange={(e) => {
                            setpromisePercent(e.target.value);
                            if (errors.percent)
                              setErrors((prev) => ({ ...prev, percent: "" }));
                          }}
                        />
                        {errors.percent && (
                          <div className="invalid-feedback d-block">
                            {errors.percent}
                          </div>
                        )}
                      </div>
                    </div>
                    {/* <!-- ========== End percent Section ========== --> */}

                    {/* <!-- ========== Start followers Section ========== --> */}
                    <div className="col-6">
                      <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                        <label
                          htmlFor="followers"
                          className="d-block fs-sm fw-semibold mb-2 text-dark"
                        >
                          Followers
                        </label>
                        <Select
                          id="followers"
                          isMulti
                          styles={reactSelectStyle("3px", "6px", true, false)}
                          placeholder="Type person name or email"
                          options={salesPersonOptionsToShow}
                          value={followersValue}
                          onChange={(val) => {
                            followersSelectionHandler(val);
                          }}
                          onInputChange={(val) => {
                            onFollowersInputChange(val);
                          }}
                        />
                      </div>
                    </div>
                    {/* <!-- ========== End followers Section ========== --> */}
                  </div>
                  {/* <!-- ========== End amount and percent Section ========== --> */}

                  {/* Invoice Items */}
                  <div className="table-wrapper pb-5 mb-5 border-bottom border-gray">
                    {/* <!-- ========== Start invoice item table ========== --> */}
                    <div className="table-responsive">
                      <table className="table align-middle fs-sm text-nowrap border-0 mb-0">
                        <thead>
                          <tr>
                            <th
                              width="40%"
                              className="description bg-transparent fs-md fw-semibold border-0"
                            >
                              Description
                            </th>
                            <th className="quantity bg-transparent fs-md fw-semibold border-0">
                              Quantity
                            </th>
                            <th className="amt bg-transparent fs-md fw-semibold border-0">
                              Price
                            </th>
                            <th
                              width="15%"
                              className="taxes bg-transparent fs-md fw-semibold border-0"
                            >
                              Tax (IVA)
                            </th>
                            <th className="pay-amt bg-transparent fs-md fw-semibold border-0">
                              Total Amount
                            </th>
                            <th className="bg-transparent fs-md fw-semibold border-0"></th>
                          </tr>
                        </thead>
                        <tbody style={{ height: "200px" }}>
                          {invoiceItemsList.map((invoiceItem, index) => {
                            return (
                              <tr key={index} style={{ verticalAlign: "top" }}>
                                <td className="description border-bottom-0 p-1">
                                  <input
                                    type="text"
                                    name="description"
                                    placeholder={t("e.g., Product description")}
                                    className="form-control bg-white shadow-none border-gray-300"
                                    value={invoiceItem.description}
                                    onChange={(e) =>
                                      changeInvoiceItemsInputs(
                                        index,
                                        "description",
                                        e.target.value
                                      )
                                    }
                                  />
                                </td>
                                <td className="quantity border-bottom-0 p-1">
                                  <input
                                    name="quantity"
                                    className="form-control bg-white shadow-none border-gray-300"
                                    type="number"
                                    placeholder={t("e.g., 1")}
                                    value={invoiceItem.quantity}
                                    onChange={(e) =>
                                      changeInvoiceItemsInputs(
                                        index,
                                        "quantity",
                                        e.target.value
                                      )
                                    }
                                  />
                                </td>
                                <td className="amt border-bottom-0 p-1">
                                  <input
                                    name="price"
                                    className="form-control bg-white shadow-none border-gray-300"
                                    type="number"
                                    placeholder={t("e.g., 100")}
                                    value={invoiceItem.price}
                                    onChange={(e) =>
                                      changeInvoiceItemsInputs(
                                        index,
                                        "price",
                                        e.target.value
                                      )
                                    }
                                  />
                                </td>
                                <td className="taxes border-bottom-0 p-0">
                                  <Select
                                    placeholder="IVA %"
                                    options={VatOptions}
                                    className="w-100 mt-1"
                                    styles={reactSelectStyle(
                                      "5px",
                                      "6px",
                                      false,
                                      false
                                    )}
                                    value={invoiceItem.taxselectedvalue}
                                    onChange={(val) =>
                                      taxSelectionHandler(index, val)
                                    }
                                  />
                                </td>
                                <td className="pay-amt border-bottom-0 p-1">
                                  <span className="form-control bg-white shadow-none border-gray-300">
                                    {invoiceItem.amount}
                                  </span>
                                </td>
                                <td className="action border-bottom-0">
                                  <Link
                                    className="text-danger"
                                    to="#"
                                    onClick={() => onDeleteInvoiceItem(index)}
                                  >
                                    <span className="d-block material-symbols-outlined">
                                      delete
                                    </span>
                                  </Link>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                    {/* <!-- ========== End invoice item table ========== --> */}

                    {/* <!-- ========== Start add new invoice item button ========== --> */}
                    {invoiceOwnerId &&
                    invoiceOwnerId.toString() !==
                      userInfo._id.toString() ? null : (
                      <div className="action d-flex gap-1">
                        <button
                          className="btn btn-outline-primary d-flex align-items-center gap-2"
                          onClick={addNewInvoiceItem}
                        >
                          <span className="material-symbols-outlined me-1">
                            add
                          </span>
                          {t("Add Item")}
                        </button>
                        <button
                          className="btn btn-primary ms-3 d-flex align-items-center gap-2"
                          onClick={saveInvoice}
                          disabled={isSaving}
                          style={{
                            cursor: isSaving ? "not-allowed" : "pointer",
                          }}
                        >
                          {isSaving ? (
                            <>
                              <span
                                className="spinner-border spinner-border-sm"
                                role="status"
                                aria-hidden="true"
                              ></span>
                              {t("Saving...")}
                            </>
                          ) : (
                            <>
                              <span className="material-symbols-outlined me-1">
                                save
                              </span>
                              {t("Save Opportunity")}
                            </>
                          )}
                        </button>
                      </div>
                    )}
                    {/* <!-- ========== End add new invoice item button ========== --> */}

                    {/* <!-- ========== Start save invoice button ========== --> */}

                    {/* <!-- ========== End save invoice button ========== --> */}
                  </div>

                  {/* Invoice final amount */}
                  <div className="table-wrapper pb-3 mb-3 border-bottom border-gray">
                    <div className="table-responsive">
                      <table className="table align-middle fs-sm text-nowrap border-0 mb-0">
                        <tbody>
                          <tr>
                            <td className="p-0 fw-semibold bg-transparent border-0">
                              {t("Total Discount")}
                            </td>
                            <td className="p-0 bg-transparent text-end border-0">
                              {totalDiscount}€
                            </td>
                          </tr>
                          <tr>
                            <td className="p-0 fw-semibold bg-transparent border-0">
                              {t("Total Tax (VAT)")}
                            </td>
                            <td className="p-0 bg-transparent text-end border-0">
                              {totalTax}€
                            </td>
                          </tr>
                          <tr>
                            <td className="p-0 fs-lg fw-semibold bg-transparent border-0">
                              {t("Total Payable Amount")}
                            </td>
                            <td className="p-0 fs-lg fw-semibold text-success bg-transparent text-end border-0">
                              {payableAmount}€
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div className="col-lg-4">
            {selectedInvoiceId ? (
              <NoteSection
                noteAccessUserList={noteAccessUserList}
                invoiceId={selectedInvoiceId}
                setShowAlert={setShowAlert}
                setAlertMessage={setAlertMessage}
                setMessageType={setMessageType}
              />
            ) : null}

            {invoiceLeadId || invoiceContactId ? (
              <div className="mt-4 note-card bg-white border border-gray-300 rounded-15 mb-3 shadow-sm position-relative overflow-hidden">
                <div
                  className="px-4 py-3 border-bottom border-gray-300"
                  style={{
                    background:
                      "linear-gradient(135deg, rgba(238, 82, 60, 0.1) 0%, rgba(255, 255, 255, 0.95) 100%)",
                  }}
                >
                  <div className="d-flex align-items-center gap-3">
                    <div
                      className="p-2 bg-primary rounded-circle d-flex align-items-center justify-content-center"
                      style={{ width: "40px", height: "40px" }}
                    >
                      <span className="material-symbols-outlined text-white fs-md">
                        person
                      </span>
                    </div>
                    <div>
                      <h4 className="fw-bold mb-1 text-dark">
                        {invoiceLeadId ? "Lead" : "Contact"} {t("Information")}
                      </h4>
                      <p className="fs-sm text-muted mb-0">
                        {t("Details of the selected ")}
                        {invoiceLeadId ? t("lead") : t("contact")}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="note-content pt-4 px-4 pb-4">
                  <div className="d-flex align-items-center gap-2 mb-2">
                    <span className="material-symbols-outlined fs-sm text-muted">
                      badge
                    </span>
                    <small className="text-muted fw-semibold">
                      {t("Name")} :{" "}
                      <Link
                        to={
                          invoiceLeadId
                            ? `/admin/crm/lead/information/${invoiceLeadId}`
                            : `/admin/crm/contact/details/timeline/${invoiceContactId}`
                        }
                      >
                        {firstName} {lastName}
                      </Link>
                    </small>
                  </div>
                  <p
                    className="text-dark lh-base mb-0"
                    style={{ fontSize: "0.95rem" }}
                  >
                    <span className="material-symbols-outlined fs-sm text-muted me-2">
                      mail
                    </span>
                    <strong>{t("Email")} : </strong> {emailAddress}
                  </p>
                  <p
                    className="text-dark lh-base mb-0"
                    style={{ fontSize: "0.95rem" }}
                  >
                    <span className="material-symbols-outlined fs-sm text-muted me-2">
                      phone
                    </span>
                    <strong>{t("Phone")} : </strong> {phoneNumber}
                  </p>
                  <p
                    className="text-dark lh-base mb-0"
                    style={{ fontSize: "0.95rem" }}
                  >
                    <span className="material-symbols-outlined fs-sm text-muted me-2">
                      cake
                    </span>
                    <strong>{t("Date of birth")} : </strong> {dateOfBirth}
                  </p>
                  {position && (
                    <p
                      className="text-dark lh-base mb-0"
                      style={{ fontSize: "0.95rem" }}
                    >
                      <span className="material-symbols-outlined fs-sm text-muted me-2">
                        work
                      </span>
                      <strong>{t("Position")} : </strong> {position}{" "}
                      {company && `at ${company}`}
                    </p>
                  )}
                  <p
                    className="text-dark lh-base mb-0"
                    style={{ fontSize: "0.95rem" }}
                  >
                    <span className="material-symbols-outlined fs-sm text-muted me-2">
                      location_on
                    </span>
                    <strong>{t("Location")} : </strong> {address}
                    {city && `, ${city}`}
                    {state && `, ${state}`}
                    {country && `, ${country}`}
                    {zipcode && `, ${zipcode}`}
                  </p>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SaveInvoicePopup;
